export const useGoogleMapButton = function () {
    const baseUrl = "https://www.google.com/maps/search/?api=1&query="

    const onClick = function (lat, lng) {
        window.open(`${baseUrl}${lat},${lng}`)
    }

    return {
        onClick
    }
}

export default useGoogleMapButton